import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { LogbookEntry, LogbookEntryDto, IValueViewModel, ComponentDefinition, GroupNameDto, ILogbookModalConfiguration, IStringDateRange, RefreshClickData, LogbookWidgetFilters, KeyValuePair, AlarmLevel, ConnectionPoint, AcquisitionStrategy, Dictionary, DigitalSetSimpleDictionary, IdentifierType, ObjectType, ConnectionPointType, TagDateValue, SaveLogbookDto, IApplicationConfiguration, IFrequency, ReprocessingTaskOptionsOverride } from '../../models';
import { ILogbookService, ILoggerService, IAuthorizationService, ICurrentApplicationService, IDateRangePickerService, toDuration, IDateAlignmentHelperService, IValuesService, ISmartGroupSelectService, IDateHelperFormatService, ISeriesService, ILogbookModalSeries, IGroupApprovalService } from '../../services';
import { logbookEntryAdded, logbookModalRefresh, refreshClick } from '../../common/events';
import { addLogbookEntryModalId, noneGroup, Roles, severityLevels } from '../../common/constants';
import { toLogbookEntryDto, toLogbookEntry } from '../../common/helpers/logBookEntryConverter';
import { ILogbookSeriesTableValue } from '../logbookSeriesTableEditor';
import { Store } from '../../stateManagement';
import { partition, toDictionary } from '../../common';
import { getFreq } from '../../services/helpers/getDefaultFreq';
import { LastLogbookEntryRequestDto } from '../../models/DTO/LastLogbookEntryRequestDto';

class AddLogbookEntryController implements angular.IComponentController {
    addLogbookEntryModalId: string = addLogbookEntryModalId;
    allowedGroupGuids: string[];
    digitalSets: DigitalSetSimpleDictionary;
    filteredLabels: string[];
    filteredSeverities: KeyValuePair<AlarmLevel, string>[] = [];
    filters: LogbookWidgetFilters;
    format: string;
    frequency: IFrequency;
    identifierGuid: string;
    initialSearch: string;
    isAnyValueModified: boolean;
    isAsync: boolean;
    isConfirmDeleteValues: boolean = true;
    isDelete: boolean;
    isDeletePopoverOpen: boolean;
    isGoingToOverwrite: boolean;
    isGroupSearchDisabled: boolean;
    isInProgress: boolean;
    isLoadingSeriesData: boolean;
    isSavePopoverOpen: boolean;
    isSaving: boolean;
    labels: string[];
    lastSeries: ILogbookSeriesTableValue[];
    model: LogbookEntry;
    selectedGroupName: string;
    taskOptionsOverride: ReprocessingTaskOptionsOverride;
    toRefreshOnClose: RefreshClickData;
    values: ILogbookSeriesTableValue[];

    readonly connectionPoints: ConnectionPoint[];
    readonly formController: angular.IFormController;
    readonly initialGroup: string;
    readonly initialGroupName: string;
    readonly initialRange: IStringDateRange;
    readonly onCancel?: () => void;
    readonly onSave?: () => void;
    readonly referenceGroup: string;
    readonly store: Store;

    private _config: IApplicationConfiguration;
    private _garbages: (() => void)[] = [];
    private _isRangeChanged: boolean;
    private _originalSeries: ILogbookModalSeries[];
    private _pristineValues: Dictionary<TagDateValue>;

    static $inject = [
        '$rootScope',
        '$scope',
        '$translate',
        '$timeout',
        'authorizationService',
        'currentApplicationService',
        'dateAlignmentHelperService',
        'dateHelperFormatService',
        'logbookService',
        'loggerService',
        'valuesService',
        'smartGroupSelectService',
        'seriesService',
        'dateRangePickerService',
        'groupApprovalService'
    ];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _$timeout: angular.ITimeoutService,
        private _authorizationService: IAuthorizationService,
        private _currentApplicationService: ICurrentApplicationService,
        private _dateAlignmentHelperService: IDateAlignmentHelperService,
        private _dateHelperFormatService: IDateHelperFormatService,
        private _logbookService: ILogbookService,
        private _loggerService: ILoggerService,
        private _valuesService: IValuesService,
        private _smartGroupSelectService: ISmartGroupSelectService,
        private _seriesService: ISeriesService,
        private _dateRangePickerService: IDateRangePickerService,
        private _groupApprovalService: IGroupApprovalService
    ) {
        this.format = this._dateHelperFormatService.getDateFormat();
        this._config = this._currentApplicationService.getApplicationConfiguration();
    }

    $onInit() {
        this.frequency = getFreq(this._config, this.frequency);
        this.model = this.emptyModel();
        this.isDelete = this.canDelete();
        this.loadLabels();

        this._$scope.$on(logbookModalRefresh, (ev, params) => {
            this._$timeout(() => this.updateModal(params));
        });
        this._$scope.$watch(() => this.selectedGroupName, () => {
            this.setInitialSearch(this.selectedGroupName);
        });

        // use hidden (not hide) to wait for complete CSS transition
        this._$timeout(() => $(`#${addLogbookEntryModalId}`).on(
            'hidden.bs.modal',
            () => this.onCloseModal()
        ));
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['initialRange'] && this.model) {
            if (this.model) {
                this.model.range = angular.copy(this.initialRange);
            }
        }
        if (changesObj['initialGroup'] && this.model) {
            if (this.model.group) {
                this.model.group.guid = this.initialGroup;
            } else {
                this.model.group = { guid: this.initialGroup } as GroupNameDto;
            }
        }
        if (changesObj['intialGroupName']?.currentValue) {
            this.selectedGroupName = this.initialGroupName;
        }
    }

    $onDestroy() {
        this._garbages.forEach(w => w());
    }

    save() {
        this.doSave(false);
    }

    saveAndBroadcast() {
        this.doSave(true);
    }

    validateIdentifier(viewModel: IValueViewModel) {
        if (viewModel.groupList[0].guid !== this.model.group.guid) {
            this.model.group.guid = viewModel.groupList[0].guid;
        }
    }

    delete() {
        this._logbookService
            .deleteEntry(this.model.id, this.isConfirmDeleteValues, this.isAsync)
            .then(() => {
                this._loggerService.logSuccess(this._$translate.instant('Entry successfully deleted.'));
                this.closeModal(toLogbookEntryDto(this.model, false));
            })
            .catch(reason => {
                this._loggerService.logError(this._$translate.instant('Entry cannot be deleted.'));
            });
        this.closeDeletePopover();
    }

    cancel() {
        if (this.onCancel) {
            this.onCancel();
        }
    }

    closeDeletePopover() {
        this.isDeletePopoverOpen = false;
        this.isConfirmDeleteValues = true;
    }

    closeSavePopover() {
        this.isSavePopoverOpen = false;
    }

    // callback when date is set
    onApply() {
        this._isRangeChanged = true;

        const aligned = this.model.range;
        if (moment(aligned.startDate).isSame(aligned.endDate)) {
            // #36875 don't allow start and end date to be the same
            aligned.endDate = moment(aligned.endDate).add(toDuration(this._config));
        }

        if (this.model) {
            if (this.isInProgress) {
                (this.model.range as unknown) = angular.copy(aligned.startDate);
            } else {
                this.model.range = angular.copy(aligned);
            }
        }

        if (this.values) {
            // as per #42413 values are updated only when creating new LBE
            if (this.isEditingEntry()) {
                this.validateAndCheckValues();
            } else {
                this.loadSeriesData()
                    .then(() => this.validateAndCheckValues());
            }
        }
    }

    onGroupChange() {
        this._$timeout(() => this.loadSeriesAndValues(this._originalSeries));
    }

    onInProgressChange() {
        if (this.isInProgress) {
            if (this.model) {
                this.model.range = this.model.range.startDate as any;
            }
        } else {
            this._dateAlignmentHelperService
                .getPrevious(moment())
                .then(data => {
                    if (this.model) {
                        this.model.range = {
                            startDate: this.model.range as any,
                            endDate: data
                        };
                    }
                });
        }
        this._isRangeChanged = true;
    }

    onValuesChange() {
        this._$timeout(() => this.validateAndCheckValues());
    }

    onLoadHistory() {
        this.isLoadingSeriesData = true;
        const series: Dictionary<ILogbookSeriesTableValue> = {};
        this.values.forEach(v => series[v.viewModel.guid] = v);
        const range = this.getBeginEnd();
        const lastEntryrequest: LastLogbookEntryRequestDto = { 
            beginDateTime: range.startDate, 
            groupGuid: this.model.group.guid, 
            categories: this.model.labels, 
            severity: this.model.severity, 
            series: Object.keys(series) };
        this._valuesService.getLastLogbookSeriesValues(lastEntryrequest)
            .then(values => {
                const index = toDictionary(values);
                this.values.forEach(v => {
                    const data = index[v.viewModel.guid];
                    v.value = data?.value;
                    v.comment = data?.comment;
                });
                // mutate object to rerender
                this.lastSeries = [...this.values];
            })
            .catch(reason => this._loggerService.logError(reason))
            .finally(() => this.isLoadingSeriesData = false);
    }

    private getFrequency(): IFrequency {
        return this.frequency && this.frequency.interval > 0
            ? this.frequency
            : { interval: this._config.interval, intervalTimeUnit: this._config.intervalTimeUnit };
    }

    private loadLabels(): angular.IPromise<void> {
        return this._logbookService
            .getAllLabels()
            .then(data => this.labels = data.map(d => d.name))
            .then(() => {
                // #43798 : force existence of some categories when using prefiltering and DB is empty
                const hasFilteredCategories = !!this.filters?.categories;
                if (hasFilteredCategories && this.labels.length === 0) {
                    this.labels = [...this.filters.categories];
                }
                this.filteredLabels = hasFilteredCategories
                    ? this.labels.filter(l => this.filters.categories.indexOf(l) >= 0)
                    : [...this.labels];
            });
    }

    // Return range from begin to end, using now as end of in progress
    // used to read values or validate range
    // DO not use to fill date picker with endDate
    private getBeginEnd(): IStringDateRange {
        const start = this.isInProgress
            ? this.model.range as unknown as string
            : this.model.range.startDate;
        const end = this.isInProgress
            ? moment()
            : this.model.range.endDate;
        return {
            startDate: moment(start).toISOString(),
            endDate: moment(end).toISOString()
        };
    }

    private validateAndCheckValues() {
        let isAnyModified = false;
        let isOverlapping = false;
        this.values.forEach(v => {
            const guid = v.viewModel.guid;
            if (v.isSpotValue && v.timestamp) {
                const range = this.getBeginEnd();
                const isBetween = moment(v.timestamp).isBetween(range.startDate, range.endDate, undefined, '[]');
                this.formController[`${guid}-timestamp`].$setValidity('timestamp', isBetween);
            }

            isOverlapping = isOverlapping || v.isOverlapping;

            // recompute modified series
            const existing = this._pristineValues[guid];
            v.isModified = this.isModified(v, existing);
            isAnyModified = isAnyModified || v.isModified;
            //isAnyExistingModified = isAnyExistingModified || (v.isModified && !!existing);
        });
        this.formController.$setValidity('overlap', !isOverlapping, this.formController);
        this.isAnyValueModified = isAnyModified;
        this.isGoingToOverwrite = isAnyModified
            && this._pristineValues
            && Object.keys(this._pristineValues).length > 0
            && _.some(Object.values(this._pristineValues), v => v.value !== null);
    }

    private isModified(v: ILogbookSeriesTableValue, original: TagDateValue): boolean {
        let isModified = (v.value !== undefined && v.value !== null)
            || (v.comment !== undefined && v.comment !== '');

        if (original) {
            isModified = v.value !== original.value;
            if (v.isSpotValue) {
                isModified = isModified
                    || v.comment !== original.comment
                    || !moment(original.timeStamp).isSame(v.timestamp);
            }
        }

        return isModified;
    }

    private loadSeriesData(): angular.IPromise<void> {
        this.isLoadingSeriesData = true;

        const series: Dictionary<ILogbookSeriesTableValue> = {};
        this.values.forEach(v => series[v.viewModel.guid] = v);
        const range = this.getBeginEnd();

        return this._valuesService
            .getLogbookSeriesValues(range.startDate, range.endDate, Object.keys(series), this.model.id)
            .then(values => {
                const index = toDictionary(values);
                this._pristineValues = index;

                this.values.forEach(v => {
                    const data = index[v.viewModel.guid];
                    // replace unmodified values
                    if (!v.isModified) {
                        // existing data over period
                        v.value = data?.value;
                        v.comment = data?.comment;
                        v.timestamp = moment(data?.timeStamp ?? range.startDate);
                        // #45996 story specifically ask not to consider overlapping for NULL values
                        v.isOverlapping = data?.isOverlapping && data?.value !== null;
                    }
                });

                // mutate object to rerender
                this.values = [...this.values];
            })
            .catch(reason => this._loggerService.logError(reason))
            .finally(() => this.isLoadingSeriesData = false);
    }

    private resetModel() {
        this.model = this.emptyModel();
    }

    private canDelete(): boolean {
        const isMine = this._authorizationService.isUser(this.model.userName);
        return this._authorizationService.isInRole(Roles.engineer)
            || this._authorizationService.isInRole(Roles.master)
            || (isMine && this._authorizationService.isInRole(Roles.operator));

    }

    private updateModal(params: ILogbookModalConfiguration): void {
        let inProgress: boolean;
        let model: LogbookEntry;
        if (params.entry && this.model?.range) {
            ({ inProgress, model } = this.buildModelFromExisting(params));
        } else {
            ({ inProgress, model } = this.buildEmptyModel(params));
        }
        this.model = model;
        if (params.identifierGuid) {
            this.identifierGuid = params.identifierGuid;
        }
        this.isAsync = params.isAsync;
        this.isDelete = this.canDelete();
        // must be updated after date is right
        this.isInProgress = inProgress;
        if (params.prefilters?.isPrefilterEntry) {
            this.filters = params.prefilters;
            this.allowedGroupGuids = angular.copy(params.allowedGroupGuids);
            this.prefilterEntries(this.filters, this.allowedGroupGuids);
        }
        if (params.series) {
            this._originalSeries = params.series;
            this.loadSeriesAndValues(params.series);
        }
        if (!this._$scope.$$phase && !this._$scope.$root.$$phase) {
            this._$scope.$apply();
        }
        if (params.taskOptionsOverride) {
            this.taskOptionsOverride = params.taskOptionsOverride;
        }
    }

    private buildEmptyModel(params: ILogbookModalConfiguration) {
        const inProgress = false;
        const model = this.emptyModel();
        if (params.group) {
            model.group = params.group;
            this.selectedGroupName = params.group.name;
        }
        if (params.range && model) {
            const freq = this.getFrequency();
            const range = this._dateRangePickerService.enforceAlignString(params.range, freq, this._config);
            model.range = range;
        }
        if (params.severity) {
            model.severity = params.severity;
        } else {
            model.severity = 0;
        }
        return { model, inProgress };
    }

    private buildModelFromExisting(params: ILogbookModalConfiguration) {
        const model = toLogbookEntry(params.entry);
        let inProgress = (model.range.startDate && !model.range.endDate);
        if (params.range) {
            inProgress = false;
            const freq = this.getFrequency();
            const range = this._dateRangePickerService.enforceAlignString(params.range, freq, this._config);
            model.range = range;
        } else {
            (model.range as unknown) = inProgress
                ? moment(params.entry.beginDateTime)
                : {
                    startDate: moment(params.entry.beginDateTime).toISOString(),
                    endDate: moment(params.entry.endDateTime).toISOString()
                };
        }
        model.severity = params.entry.severity ? params.entry.severity : 0;
        model.id = params.entry.logbookEntryId;
        return { model, inProgress };
    }

    private loadSeriesAndValues(series: ILogbookModalSeries[]) {
        if (series.length === 0) {
            this.values = [];
            return;
        }

        const vms = this.store.valueViewModels.dictionary;
        const groups = this.store.groups.dictionary;
        const filtered = series
            .map(s => ({ isBound: s.isBoundToGroup, sv: this.buildLogbookSeriesValue(s.vm) }))
            .filter(s => s.sv.isManual || s.sv.isSpotValue)
            .map((s, i) => ({ guid: s.sv.viewModel.guid, order: i, isBound: s.isBound, sv: s.sv }));
        const { keep: toBind, remove: notBound } = partition(filtered, s => s.isBound);

        // If not by group, toGroup will be null, don't bin then
        const toGroup = groups[this.model.group.guid];
        const bindings = toGroup ? this._seriesService.bindSeriesToReference(
            toBind.map(s => s.guid),
            vms,
            groups,
            groups[this.referenceGroup],
            groups[this.model.group.guid]
        ) : { map: {} };

        const concat = toBind
            .map(s => ({ guid: bindings.map[s.guid] ?? s.guid, order: s.order }))
            .map(s => ({ sv: this.buildLogbookSeriesValue(vms[s.guid]), order: s.order }))
            .concat(notBound.map(s => ({ sv: s.sv, order: s.order })));

        this.values = _.orderBy(concat, s => s.order).map(s => s.sv);

        if (this.values?.length > 0) {
            this.loadSeriesData()
                .then(() => this.validateAndCheckValues())
                .then(() => this.checkApproval());
        }
    }

    private checkApproval() {
        const manuals = this.values.filter(v => !v.isSpotValue);
        const groups = manuals.flatMap(v => v.viewModel.groupList.map(g => g.guid));
        const range = this.getBeginEnd();
        this._groupApprovalService
            .isRangeApproved({ guidList: groups, dateTimeList: [] }, range.startDate, range.endDate)
            .then(data =>
                manuals
                    .filter(m => _.some(m.viewModel.groupList, g => data[g.guid]?.length > 0))
                    .forEach(m => m.isApproved = true)
            );
    }

    private buildLogbookSeriesValue(vm: IValueViewModel): ILogbookSeriesTableValue {
        const cp = this.store.connectionPoints.dictionary[vm.acquisitionPointGuid];
        const isManual = cp?.type === ConnectionPointType.Manual;
        const isSpotValue = isManual && vm.acquisitionStrategy === AcquisitionStrategy.Spot;
        const isValidated = vm.objectType === ObjectType.Identifier && vm.identifierType === IdentifierType.Validated;
        const digital = this.store.digitalSets.dictionary[vm.digitalSetGuid]?.stateCollection.map(d => d);
        return {
            decimals: 2,
            digitalSet: digital ? [{ code: null, name: '-' }].concat(digital) : undefined,
            isApproved: false,
            isModified: false,
            isManual,
            isOverlapping: false,
            isSpotValue,
            isValidated,
            timestamp: this.getStartDate(),
            value: undefined,
            viewModel: vm
        };
    }

    private getStartDate(): moment.Moment {
        return this.model.range.startDate ?? this.model.range as any;
    }

    private prefilterEntries(filters: LogbookWidgetFilters, allowedGroupGuids: string[]): void {
        if (filters?.isPrefilterEntry ?? false) {
            this.setSeverities(filters);
            this.setSelectedGroup(allowedGroupGuids, filters);
            this.setCategories(filters);
        } else {
            this.filteredSeverities = undefined;
            this.filteredLabels = this.labels;
        }
    }

    private setCategories(filters: LogbookWidgetFilters) {
        if (filters.categories && filters.categories.length > 0) {
            this.filteredLabels = this.labels.filter(label => filters.categories.indexOf(label) >= 0);
            if (this.filteredLabels.length > 0 && !this.isEditingEntry()) {
                this.model.labels.push(this.filteredLabels[0]);
            }
        }
    }

    private setSelectedGroup(allowedGroupGuids: string[], filters: LogbookWidgetFilters) {
        if (allowedGroupGuids && allowedGroupGuids.length > 0) {
            this.isGroupSearchDisabled = filters.isPrefilterEntry;
            const currentGroup = this.model.group?.guid;
            // by default first group of list
            let guid = allowedGroupGuids[0];
            this._smartGroupSelectService
                .smartGroupSelect(currentGroup, filters.groupTypes, this.store.groups.dictionary)
                .then(group => {
                    guid = group?.guid ?? guid;
                }).finally(() => {
                    this.model.group.guid = guid;
                    this.selectedGroupName = this.store.groups.dictionary[guid]?.name;
                });
        }
    }

    private setSeverities(filters: LogbookWidgetFilters) {
        if (filters.severities && filters.severities.length > 0) {
            this.filteredSeverities = filters.severities.map(allowedSeverity => severityLevels.find(sl => sl.value === allowedSeverity.toString()));
            this.model.severity = this.filteredSeverities[0].key;
        }
    }

    private doSave(isBroadcast: boolean) {
        this.isSaving = true;

        const entry = toLogbookEntryDto(this.model, isBroadcast, this.isInProgress);
        const isUpdate = this.model.id > 0;

        const values = this.values ?
            this.values
                .filter(v => v.isModified || (isUpdate && this.isModified(v, undefined)))
                .map(v => {
                    return {
                        guid: v.viewModel.guid,
                        timeStamp: v.timestamp?.toISOString(),
                        value: v.value,
                        comment: v.comment
                    } as TagDateValue;
                })
            : [];

        const toSave: SaveLogbookDto = { entry, values, isAsync: this.isAsync };

        const promise = isUpdate
            ? this.performUpdate(toSave)
            : this.performSave(toSave);

        promise
            .then(data => {
                if (this.onSave) {
                    this.onSave();
                }
                return this.loadLabels().then(() => data);
            })
            .then(data => this.closeModal(data))
            .finally(() => this.isSaving = false);
        this.closeSavePopover();
    }

    private closeModal(entry: LogbookEntryDto) {
        $(`#${addLogbookEntryModalId}`).modal('hide');
        this.resetPrefilters();
        this.toRefreshOnClose = {
            beginDate: entry.beginDateTime,
            endDate: entry.endDateTime ?? moment().toISOString(),
            force: true,
            isLogbookEntryUpdated: true
        };
    }

    private performSave(toSave: SaveLogbookDto): angular.IPromise<LogbookEntryDto> {
        return this._logbookService
            .add(toSave, this.taskOptionsOverride)
            .then(data => {
                this._loggerService.logSuccess(this._$translate.instant('Entry successfully saved.', true));
                this._$rootScope.$broadcast(logbookEntryAdded, data);
                return data;
            });
    }

    private performUpdate(toSave: SaveLogbookDto): angular.IPromise<LogbookEntryDto> {
        toSave.isUpdatingValues = this.isAnyValueModified || this._isRangeChanged;
        return this._logbookService
            .update([toSave], this.taskOptionsOverride)
            .then(data => {
                this._loggerService.logSuccess(this._$translate.instant('Entry successfully updated.', true));
                return data[0];
            });
    }

    private emptyModel(): LogbookEntry {
        this.identifierGuid = undefined;
        this.isInProgress = false;
        const range = this.initialRange
            ? Object.assign({}, this.initialRange)
            : {
                startDate: null as string,
                endDate: null as string
            };
        if (this.model) {
            this.model.range = angular.copy(range);
        }
        return {
            range,
            severity: 0,
            group: { guid: this.initialGroup },
            labels: []
        } as LogbookEntry;
    }

    private setInitialSearch(groupName: string) {
        this.initialSearch = (groupName && groupName !== noneGroup.value)
            ? 'g:' + groupName
            : '';
    }

    private resetPrefilters() {
        this.allowedGroupGuids = [];
        this.filters = undefined;
        this.prefilterEntries(this.filters, this.allowedGroupGuids);
        this.values = undefined;
    }

    private isEditingEntry() {
        return this.model.id > 0;
    }

    private onCloseModal() {
        this.cancel();
        this.resetModel();
        if (this.toRefreshOnClose) {
            this._$rootScope.$broadcast(refreshClick, this.toRefreshOnClose);
            this.toRefreshOnClose = null;
        }
        if (!this._$scope.$$phase && !this._$scope.$root.$$phase) {
            this._$scope.$apply();
        }
        this.resetPrefilters();
    }
}

export const wtAddLogbookEntry: ComponentDefinition = {
    componentId: 'wtAddLogbookEntry',
    controller: AddLogbookEntryController,
    controllerAs: 'vm',
    template: require('./addLogbookEntry.component.html'),
    bindings: {
        initialGroup: '<?',
        initialGroupName: '<?',
        initialRange: '<?',
        onCancel: '&?',
        onSave: '&?',
        referenceGroup: '<?',
        store: '<?'
    }
};